import moment from "moment";
import {
  capitalizeFirstCharacter,
  extractNameCodePairs,
  extractNames,
  generateRandomNumber,
  getProductCodeLength,
  getSelectedCountryByCode,
  getValueByCode,
} from "./helper";
import {
  formatTimeToShip,
  getTimeToShipUnitValue,
  getTimeToShipValue,
} from "./postDataHelpers/CatalogHelper";
import { getProfileId, toTitleCase } from "./validationUtils";
import {
  getNameByCode,
  getValueByPath,
  parseDbObjectInsideArray,
} from "./validationHelper";
import { VARIANT_PRODUCT_TABLE_HEADER } from "./data";

export const validateProductDetails = (productDetails, productCodeList) => {
  let allVariants = [...productDetails];

  console.log("productCodeListproductCodeList_5", productCodeList);

  let isError = false;

  const seenCombinations = [];
  const seenVariants = [];
  const seenThreeCombinations = [];

  productDetails.forEach((product, index) => {
    let errors = null;

    let variant1 = product?.variant1;
    let variant2 = product?.variant2;
    let variant3 = product?.variant3;

    if (product?.variant1 && !product?.variant2 && !product?.variant3) {
      variant1 = validateVariant(product?.variant1);

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }

      if (!variant1?.error) {
        if (seenVariants.includes(product.variant1.inputValue)) {
          variant1 = {
            error: true,
            item: {
              ...variant1?.item,
              error: "Variant values should be unique",
            },
          };
          errors = {
            ...errors,
            variant1: true,
          };
        } else {
          seenVariants.push(product.variant1.inputValue);
          delete errors?.variant1;
        }
      }
    }

    if (product?.variant1 && product?.variant2 && !product?.variant3) {
      variant1 = validateVariant(product?.variant1);
      variant2 = validateVariant(product?.variant2);

      const combination = `${product.variant1.inputValue}-${product.variant2.inputValue}`;

      // Check if this combination is already in the seenCombinations array

      console.log("variant1 and variant2", variant1, variant2);

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }
      if (variant2?.error) {
        errors = {
          ...errors,
          variant2: true,
        };
      } else {
        delete errors?.variant2;
      }

      if (!variant1?.error && !variant2?.error) {
        if (seenCombinations.includes(combination)) {
          console.log("Combination repeated", index);
          // variant1 = {
          //   error: true,
          //   item: { ...variant1?.item, error: "Combination is repeated" },
          // };
          variant2 = {
            error: true,
            item: { ...variant2?.item, error: "Combination is repeated" },
          };
          errors = {
            ...errors,
            variant2: true,
          };
        } else {
          seenCombinations.push(combination);
          delete errors?.variant2;
        }
      }
    }

    if (product?.variant1 && product?.variant2 && product?.variant3) {
      variant1 = validateVariant(product?.variant1);
      variant2 = validateVariant(product?.variant2);
      variant3 = validateVariant(product?.variant3);

      const combination = `${product.variant1.inputValue}-${product.variant2.inputValue}-${product.variant3.inputValue}`;

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }
      if (variant2?.error) {
        errors = {
          ...errors,
          variant2: true,
        };
      } else {
        delete errors?.variant2;
      }
      if (variant3?.error) {
        errors = {
          ...errors,
          variant3: true,
        };
      } else {
        delete errors?.variant3;
      }

      if (!variant1?.error && !variant2?.error && !variant3?.error) {
        if (seenThreeCombinations.includes(combination)) {
          console.log("Combination repeated", index);
          // variant1 = {
          //   error: true,
          //   item: { ...variant1?.item, error: "Combination is repeated" },
          // };
          variant3 = {
            error: true,
            item: { ...variant3?.item, error: "Combination is repeated" },
          };
          errors = {
            ...errors,
            variant3: true,
          };
        } else {
          seenThreeCombinations.push(combination);
          delete errors?.variant3;
        }
      }
    }

    if (
      !product?.productCodeKey ||
      product?.productCodeKey === "Select Product Code"
    ) {
      errors = {
        ...errors,
        productCodeKey: "Select Product Code",
      };
    } else {
      delete errors?.productCodeKey;
    }

    if (!product?.productCodeValue) {
      errors = {
        ...errors,
        productCodeValue: "Enter value",
      };
    } else {
      delete errors?.productCodeValue;
    }

    if (product?.productCodeKey && product?.productCodeValue) {
      const productCodeLookup = productCodeList?.find(
        (obj) => obj?.prodictCode === product?.productCodeKey
      );

      console.log("productCodeLookupproductCodeLookup5", productCodeLookup);

      let pcError = true;
      productCodeLookup?.validation?.forEach((pattern) => {
        const regex = new RegExp(
          pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
        );
        if (regex.test(product?.productCodeValue)) {
          pcError = false;
        }
      });

      if (pcError) {
        errors = {
          ...errors,
          productCodeValue: `Enter valid ${getProductCodeLength(
            productCodeList,
            product?.productCodeKey
          )} digit product code`,
        };
      }
    }
    if (!product?.photo1 || product?.photo1 === "") {
      errors = {
        ...errors,
        photo1: "Add product image",
      };
    } else {
      delete errors?.photo1;
    }

    if (!product?.originalPrice) {
      errors = {
        ...errors,
        originalPrice: "Enter original price",
      };
    } else {
      delete errors?.originalPrice;
    }

    if (!product?.offerPrice) {
      errors = {
        ...errors,
        offerPrice: "Enter offer price",
      };
    } else {
      delete errors?.offerPrice;
    }

    if (product?.offerPrice && product?.originalPrice) {
      if (Number(product?.offerPrice) > Number(product?.originalPrice)) {
        errors = {
          ...errors,
          offerPrice:
            "Offer Price must be less than or equal to Original Price",
        };
      }
    }

    if (!product?.qty) {
      errors = {
        ...errors,
        qty: "Enter qty on hand",
      };
    } else {
      delete errors?.qty;
    }

    if (!product?.alertQty) {
      errors = {
        ...errors,
        alertQty: "Enter alert qty",
      };
    } else {
      delete errors?.alertQty;
    }

    if (!product?.minQty) {
      errors = {
        ...errors,
        minQty: "Enter minimum qty",
      };
    } else {
      delete errors?.minQty;
    }

    if (!product?.maxQty) {
      errors = {
        ...errors,
        maxQty: "Enter maximum qty",
      };
    } else {
      delete errors?.maxQty;
    }

    if (product?.qty && product?.alertQty && product?.maxQty) {
      if (
        Number(product?.qty) <= Number(product?.alertQty) ||
        Number(product?.qty) < Number(product?.maxQty)
      ) {
        errors = {
          ...errors,
          qty: "Qty On Hand should be greater than Alert Qty & Max Qty",
        };
      } else {
        delete errors?.qty;
      }
    }

    if (product?.maxQty && product?.minQty) {
      if (Number(product?.maxQty) < Number(product?.minQty)) {
        errors = {
          ...errors,
          maxQty: "Max Qty per order should be greater than Min Qty per order",
        };
      } else {
        delete errors?.maxQty;
      }
    }

    if (!product?.productWeight) {
      errors = {
        ...errors,
        productWeight: "Enter product weight",
      };
    } else {
      delete errors?.productWeight;
    }

    if (!product?.netProductWeight || product?.netProductWeight === "") {
      errors = {
        ...errors,
        netProductWeight: "Enter net product weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (
      product?.netProductWeight !== "" &&
      product?.netProductWeight <= product?.productWeight
    ) {
      errors = {
        ...errors,
        netProductWeight:
          "Net Product Weight should be more than Product Weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (errors) {
      allVariants[index] = {
        ...allVariants[index],
        variant1: variant1?.item,
        variant2: variant2 && variant2?.item,
        variant3: variant3 && variant3?.item,
        errors: errors,
      };
      isError = true;
    } else {
      allVariants[index] = {
        ...allVariants[index],
        variant1: variant1?.item,
        variant2: variant2 && variant2?.item,
        variant3: variant3 && variant3?.item,
        errors: null,
      };
    }
  });

  console.log("validate_Products_Verified:", allVariants);
  console.log("validate_Products_isError:", isError);

  return {
    allVariants,
    isError,
  };
};
export const validateEditProductDetails = (productDetails, productCodeList) => {
  let allVariants = [...productDetails];

  let isError = false;

  const seenCombinations = [];
  const seenVariants = [];
  const seenThreeCombinations = [];

  productDetails.forEach((product, index) => {
    let errors = null;

    let variant1 = product?.variant1;
    let variant2 = product?.variant2;
    let variant3 = product?.variant3;

    if (product?.variant1 && !product?.variant2 && !product?.variant3) {
      variant1 = validateVariant(product?.variant1);

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }

      if (!variant1?.error) {
        if (seenVariants.includes(product.variant1.inputValue)) {
          variant1 = {
            error: true,
            item: {
              ...variant1?.item,
              error: "Variant values should be unique",
            },
          };
          errors = {
            ...errors,
            variant1: true,
          };
        } else {
          seenVariants.push(product.variant1.inputValue);
          delete errors?.variant1;
        }
      }
    }

    if (product?.variant1 && product?.variant2 && !product?.variant3) {
      variant1 = validateVariant(product?.variant1);
      variant2 = validateVariant(product?.variant2);

      const combination = `${product.variant1.inputValue}-${product.variant2.inputValue}`;

      // Check if this combination is already in the seenCombinations array

      console.log("variant1 and variant2", variant1, variant2);

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }
      if (variant2?.error) {
        errors = {
          ...errors,
          variant2: true,
        };
      } else {
        delete errors?.variant2;
      }

      if (!variant1?.error && !variant2?.error) {
        if (seenCombinations.includes(combination)) {
          console.log("Combination repeated", index);
          // variant1 = {
          //   error: true,
          //   item: { ...variant1?.item, error: "Combination is repeated" },
          // };
          variant2 = {
            error: true,
            item: { ...variant2?.item, error: "Combination is repeated" },
          };
          errors = {
            ...errors,
            variant2: true,
          };
        } else {
          seenCombinations.push(combination);
          delete errors?.variant2;
        }
      }
    }

    if (product?.variant1 && product?.variant2 && product?.variant3) {
      variant1 = validateVariant(product?.variant1);
      variant2 = validateVariant(product?.variant2);
      variant3 = validateVariant(product?.variant3);

      const combination = `${product.variant1.inputValue}-${product.variant2.inputValue}-${product.variant3.inputValue}`;

      if (variant1?.error) {
        errors = {
          ...errors,
          variant1: true,
        };
      } else {
        delete errors?.variant1;
      }
      if (variant2?.error) {
        errors = {
          ...errors,
          variant2: true,
        };
      } else {
        delete errors?.variant2;
      }
      if (variant3?.error) {
        errors = {
          ...errors,
          variant3: true,
        };
      } else {
        delete errors?.variant3;
      }

      if (!variant1?.error && !variant2?.error && !variant3?.error) {
        if (seenThreeCombinations.includes(combination)) {
          console.log("Combination repeated", index);
          // variant1 = {
          //   error: true,
          //   item: { ...variant1?.item, error: "Combination is repeated" },
          // };
          variant3 = {
            error: true,
            item: { ...variant3?.item, error: "Combination is repeated" },
          };
          errors = {
            ...errors,
            variant3: true,
          };
        } else {
          seenThreeCombinations.push(combination);
          delete errors?.variant3;
        }
      }
    }

    if (
      !product?.productCodeKey ||
      product?.productCodeKey === "Select Product Code"
    ) {
      errors = {
        ...errors,
        productCodeKey: "Select Product Code",
      };
    } else {
      delete errors?.productCodeKey;
    }

    if (!product?.productCodeValue) {
      errors = {
        ...errors,
        productCodeValue: "Enter value",
      };
    } else {
      delete errors?.productCodeValue;
    }

    if (product?.productCodeKey && product?.productCodeValue) {
      const productCodeLookup = productCodeList?.find(
        (obj) => obj?.prodictCode === product?.productCodeKey
      );

      console.log("productCodeLookupproductCodeLookup5", productCodeLookup);

      let pcError = true;
      productCodeLookup?.validation?.forEach((pattern) => {
        const regex = new RegExp(
          pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
        );
        if (regex.test(product?.productCodeValue)) {
          pcError = false;
        }
      });

      if (pcError) {
        errors = {
          ...errors,
          productCodeValue: `Enter valid ${getProductCodeLength(
            productCodeList,
            product?.productCodeKey
          )} digit product code`,
        };
      }
    }

    if (!product?.photo1 || product?.photo1 === "") {
      errors = {
        ...errors,
        photo1: "Add product image",
      };
    } else {
      delete errors?.photo1;
    }
    if (!product?.description || product?.description === "") {
      errors = {
        ...errors,
        description: "Enter description",
      };
    } else {
      delete errors?.description;
    }

    if (!product?.productId) {
      if (!product?.originalPrice) {
        errors = {
          ...errors,
          originalPrice: "Enter original price",
        };
      } else {
        delete errors?.originalPrice;
      }

      if (!product?.offerPrice) {
        errors = {
          ...errors,
          offerPrice: "Enter offer price",
        };
      } else {
        delete errors?.offerPrice;
      }

      if (product?.offerPrice && product?.originalPrice) {
        if (Number(product?.offerPrice) > Number(product?.originalPrice)) {
          errors = {
            ...errors,
            offerPrice:
              "Offer Price must be less than or equal to Original Price",
          };
        }
      }

      if (!product?.qty) {
        errors = {
          ...errors,
          qty: "Enter qty on hand",
        };
      } else {
        delete errors?.qty;
      }

      if (!product?.alertQty) {
        errors = {
          ...errors,
          alertQty: "Enter alert qty",
        };
      } else {
        delete errors?.alertQty;
      }

      if (!product?.minQty) {
        errors = {
          ...errors,
          minQty: "Enter minimum qty",
        };
      } else {
        delete errors?.minQty;
      }

      if (!product?.maxQty) {
        errors = {
          ...errors,
          maxQty: "Enter maximum qty",
        };
      } else {
        delete errors?.maxQty;
      }

      if (product?.qty && product?.alertQty && product?.maxQty) {
        if (
          Number(product?.qty) <= Number(product?.alertQty) ||
          Number(product?.qty) < Number(product?.maxQty)
        ) {
          errors = {
            ...errors,
            qty: "Qty On Hand should be greater than Alert Qty & Max Qty",
          };
        } else {
          delete errors?.qty;
        }
      }

      if (product?.maxQty && product?.minQty) {
        if (Number(product?.maxQty) < Number(product?.minQty)) {
          errors = {
            ...errors,
            maxQty:
              "Max Qty per order should be greater than Min Qty per order",
          };
        } else {
          delete errors?.maxQty;
        }
      }
    }

    if (!product?.productWeight) {
      errors = {
        ...errors,
        productWeight: "Enter product weight",
      };
    } else {
      delete errors?.productWeight;
    }

    if (!product?.netProductWeight || product?.netProductWeight === "") {
      errors = {
        ...errors,
        netProductWeight: "Enter net product weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (
      product?.netProductWeight !== "" &&
      product?.netProductWeight <= product?.productWeight
    ) {
      errors = {
        ...errors,
        netProductWeight:
          "Net Product Weight should be more than Product Weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (errors) {
      allVariants[index] = {
        ...allVariants[index],
        variant1: variant1?.item,
        variant2: variant2 && variant2?.item,
        variant3: variant3 && variant3?.item,
        errors: errors,
      };
      isError = true;
    } else {
      allVariants[index] = {
        ...allVariants[index],
        variant1: variant1?.item,
        variant2: variant2 && variant2?.item,
        variant3: variant3 && variant3?.item,
        errors: null,
      };
    }
  });

  console.log("validate_Products_Verified:", allVariants);
  console.log("validate_Products_isError:", isError);

  return {
    allVariants,
    isError,
  };
};

const validateVariant = (item) => {
  if (item?.type === "default") {
    return { item, error: false };
  }
  if (!item?.inputValue && item?.type !== "radioButton") {
    return {
      item: { ...item, error: "Please enter the value" },
      error: true,
    };
  }
  if (
    item?.type == "radioButton" &&
    item?.radioOptions?.every((obj) => obj.value === "")
  ) {
    return {
      item: { ...item, error: "Please select, it's a mandatory value" },
      error: true,
    };
  }

  if (!item?.inputValue || item?.validation?.length === 0) {
    return { item: { ...item, error: "" }, error: false };
  }

  for (let validation of item?.validation) {
    if (validation.substring(0, 5) !== "regex") {
      if (validation === item?.inputValue) {
        return { item: { ...item, error: "" }, error: false };
      }
    } else {
      const regexString = validation.match(/regex\((.+)\)/)[1];
      const regexPattern = regexString
        .replace(/d/g, "\\d")
        .replace(/\./g, "\\.");
      const regex = new RegExp(regexPattern);
      console.log(
        "regex inputValue",
        validation,
        regexPattern,
        item?.inputValue
      );
      if (regex.test(item?.inputValue)) {
        console.log("validation success");
        return { item: { ...item, error: "" }, error: false };
      }
    }
  }

  return { item: { ...item, error: "Please enter valid format" }, error: true };
};

export const validateOndcSpecs = (productDetails) => {
  // console.log("validateOndcProductSpecs__productDetails:", productDetails);

  const productList = [...productDetails];
  const allVariants = [];

  let isError = false;

  productList.forEach((productInfo) => {
    const productSpecs = [...productInfo?.specList];

    let specificationError = false;

    const updatedSpecsArray = productSpecs?.map((item) => {
      if (item?.type === "default") {
        return item;
      }
      if (
        !item?.inputValue &&
        item?.required?.toLowerCase() === "m" &&
        item?.type !== "radioButton"
      ) {
        specificationError = true;
        return { ...item, error: "Please enter, it's a mandatory value" };
      }
      if (
        item?.required?.toLowerCase() === "m" &&
        item?.type == "radioButton" &&
        item?.radioOptions?.every((obj) => obj.value === "")
      ) {
        specificationError = true;
        return { ...item, error: "Please select, it's a mandatory value" };
      }

      if (!item?.inputValue || item?.validation?.length === 0) {
        return { ...item, error: "" };
      }

      // const validationArray = JSON.parse(item?.validation);

      // console.log("validationArray", validationArray);

      // if (validationArray?.length === 0) {
      //   return { ...item, error: "" };
      // }

      for (let validation of item?.validation) {
        if (validation.substring(0, 5) !== "regex") {
          if (validation === item?.inputValue) {
            return { ...item, error: "" };
          }
        } else {
          const regexString = validation.match(/regex\((.+)\)/)[1];
          const regexPattern = regexString
            .replace(/d/g, "\\d")
            .replace(/\./g, "\\.");
          const regex = new RegExp(regexPattern);
          console.log(
            "regex inputValue",
            validation,
            regexPattern,
            item?.inputValue
          );
          if (regex.test(item?.inputValue)) {
            console.log("validation success");
            return { ...item, error: "" };
          }
        }
      }

      specificationError = true;
      return { ...item, error: "Please enter valid format" };
    });

    allVariants.push({
      ...productInfo,
      specList: updatedSpecsArray,
      specificationError,
    });

    if (specificationError && !isError) {
      isError = true;
    }
  });

  console.log("validateOndcProductSpecs__allVariants:", {
    allVariants,
    isError,
  });
  return { allVariants, isError };
};

export const getOndcErrorCount = (specListData) => {
  let count = 0;

  specListData.forEach((item) => {
    if (
      item?.error !== "" &&
      item?.required?.toLowerCase() == "m" &&
      item?.type != "default"
    ) {
      count = count + 1;
    }
  });

  return count;
};

export const preparePreviewVariantData = ({
  productInfo,
  selectedVariant,
  ondcData,
  variantData,
  tableHeader1,
  tableHeader2,
}) => {
  let productTable1 = [...tableHeader1];
  const firstElement = productTable1.shift();
  productTable1?.pop();
  productTable1.push(firstElement);
  let productTable2 = [...tableHeader2];
  productTable2?.pop();
  const ondcDetails = {
    ondcEnabled: "Yes",
    timeToShip: ondcData?.timeToShip,
    timeUnit: ondcData?.timeToShipUnit?.label,
    cod: ondcData?.available_on_cod ? "Yes" : "No",
    fragile: ondcData?.fragile ? "Yes" : "No",
    returnable: ondcData?.returnTerms?.returnable,
    returnPeriod: ondcData?.returnTerms?.returnPeriod,
    sellerPickup: ondcData?.returnTerms?.seller_pickup_return,
    cancellable: ondcData?.cancelTerms?.cancellable,
    refundEligible: ondcData?.cancelTerms?.refundEligible,
    cancellationFee: ondcData?.cancelTerms?.cancellationFeePercentage,
    productCode: ondcData?.productCode?.key,
    productCodeValue: ondcData?.productCode?.value,
    unitOfMeasure: ondcData?.unitOfMeasure?.unit,
    unitOfMeasureValue: ondcData?.unitOfMeasure?.value,
  };
  return {
    productInfo,
    variant1: {
      value: selectedVariant?.variant1?.value?.displayName,
      tag: selectedVariant?.variant1?.tag ? "Yes" : "No",
    },
    variant2: {
      value: selectedVariant?.variant2?.value?.displayName,
      tag: selectedVariant?.variant2?.tag ? "Yes" : "No",
    },
    ondcDetails,
    variantData,
    tableHeader1: productTable1,
    tableHeader2: productTable2,
  };
};

export const prepareVariantList = (ondcList, unitOfMeasurementData) => {
  const values = unitOfMeasurementData?.map((obj) => obj?.value);
  const ondcSpecList = ondcList?.filter((item) => item?.display != "N");
  return [
    ...ondcSpecList,
    {
      displayName: "Unit of measure",
      inputValue: "",
      code: "uom",
      value: "uom",
      type: "data",
      id: "1",
      values,
      validation: [],
    },
  ];
};

export const prepareMainVariant = ({
  productInfo,
  selectedVariant,
  categoryInfo,
  ondcInfo,
  businessInfo,
}) => {
  console.log("DATA_", productInfo, selectedVariant, categoryInfo, ondcInfo);
  const profileId = getProfileId();
  const businessId = sessionStorage.getItem("selectedBusinessId");

  const refLinkList = productInfo?.refLinks?.filter(
    (item) => item?.code !== "" && item?.link !== ""
  );
  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";
  const variantId = generateRandomNumber();

  const attributesList = [
    {
      code: "variant1",
      value: selectedVariant?.variant1?.value?.code,
      tag: selectedVariant?.variant1?.tag ? true : false,
      ondcAttribute:
        selectedVariant?.variant1?.value?.code === "uom"
          ? "unitOfMeasure"
          : "attributeList",
    },
    {
      code: "variant2",
      value: selectedVariant?.variant2?.value?.code,
      tag: selectedVariant?.variant2?.tag ? true : false,
      ondcAttribute:
        selectedVariant?.variant2?.value?.code === "uom"
          ? "unitOfMeasure"
          : "attributeList",
    },
  ];

  const ondcPost = {
    productDisplayUnitOfMeasure: ondcInfo?.unitOfMeasure,
    netProductWeight: 0,
    ondcEnabled: "yes",

    ondc: {
      productCode: ondcInfo?.productCode,
      fragile: ondcInfo?.fragile,
      available_on_cod: ondcInfo?.available_on_cod,

      timeToShip: ondcInfo?.timeToShip
        ? formatTimeToShip(ondcInfo?.timeToShipUnit?.unit, ondcInfo?.timeToShip)
        : "",

      cancelTerms: {
        ...ondcInfo?.cancelTerms,
        cancellable: ondcInfo?.cancelTerms?.cancellable?.toLowerCase(),

        refundEligible: ondcInfo?.cancelTerms?.refundEligible?.toLowerCase(),
        cancellationFeeAmount: null,
      },

      returnTerms: {
        ...ondcInfo?.returnTerms,
        returnable: ondcInfo?.returnTerms?.returnable?.toLowerCase(),

        returnPeriod: ondcInfo?.returnTerms?.returnPeriod
          ? `P${ondcInfo?.returnTerms?.returnPeriod}D`
          : "",

        seller_pickup_return:
          ondcInfo?.returnTerms?.seller_pickup_return?.toLowerCase(),
      },
    },
  };
  return {
    variantInfo: {
      variantId,
      masterVariant: true,
      masterProductVariantId: "",
      masterProductName: productInfo?.productName,
      variantSequence1: "",
      variants: attributesList,
    },
    profileId: profileId,
    businessId: businessId,
    productName: productInfo?.productName,
    productDescription: productInfo?.description,
    catalogType: "Product",
    label: [],
    searchText: "",
    brand: productInfo?.brand,
    origin: productInfo?.country?.ondcCountryCode || "",
    skuId: "",
    refLink: refLinkList || [],
    productPhoto: null,
    latitude: lat,
    longitude: long,
    status: "active",
    commerceEnabled: "YES",
    hyperLocal: "Y",
    productMainCategory: [
      {
        ...categoryInfo?.selectedBusinessCat,
        ondcCode: categoryInfo?.selectedOndcCat?.code || null,
        ondcValue: categoryInfo?.selectedOndcCat?.name || null,
        value: categoryInfo?.selectedBusinessCat?.name || null,
      },
    ],
    productSubCategory: categoryInfo?.selectedProductCat
      ? [
          {
            ...categoryInfo?.selectedProductCat,
            ondcSubCode: categoryInfo?.selectedOndcSubCat?.scCode1 || null,
            ondcSubValue:
              categoryInfo?.selectedOndcSubCat?.productSubCategory1 || null,
          },
        ]
      : [],
    productSubCategory2: categoryInfo?.selectedProductSubCat
      ? [
          {
            ...categoryInfo?.selectedProductSubCat,
            ondcSub2Code: null,
            ondcSub2Value: null,
          },
        ]
      : [],

    commerceStartDate: null,
    commerceEndDate: null,
    minOrderQuantity: null,
    maxOrderQuantity: null,
    productOriginalPrice: null,
    productSalePrice: null,
    gstInfo: {
      code:
        `${ondcInfo?.productCode?.key}:${ondcInfo?.productCode?.value}` || "",
      gstPercentage: productInfo?.gstPercentage || "",
    },
    measurementInfo: {
      weight: null,
      length: null,
      width: null,
      height: null,
    },
    taxDetails: [
      {
        code: "Inclusive of taxes",
        name: "Taxes Included",
        value: "false",
      },
    ],
    currencySymbol: "₹",
    unitOfMeasure: "Gram",
    availability: ["Yes"],
    deliveryType: [],
    shipmentDistance: "0",
    preference: 0,
    availableQuantity: null,
    soldQuantity: 0,
    alertQuantity: null,
    subscription: null,
    ...ondcPost,
  };
};
export const prepareEditMainVariantData = ({
  productInfo,
  selectedVariant,
  categoryInfo,
  ondcInfo,
  businessInfo,
  productDetails,
}) => {
  console.log("DATA_", productInfo, selectedVariant, categoryInfo, ondcInfo);
  const profileId = getProfileId();
  const businessId = sessionStorage.getItem("selectedBusinessId");

  const refLinkList = productInfo?.refLinks?.filter(
    (item) => item?.code !== "" && item?.link !== ""
  );
  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";
  const variantId = productDetails?.variantInfo?.variantId;

  const attributesList = [
    {
      code: "variant1",
      value: selectedVariant?.variant1?.value?.code,
      tag: selectedVariant?.variant1?.tag ? true : false,
      ondcAttribute:
        selectedVariant?.variant1?.value?.code === "uom"
          ? "unitOfMeasure"
          : "attributeList",
    },
    ...(selectedVariant?.variant2?.value
      ? [
          {
            code: "variant2",
            value: selectedVariant?.variant2?.value?.code,
            tag: selectedVariant?.variant2?.tag ? true : false,
            ondcAttribute:
              selectedVariant?.variant2?.value?.code === "uom"
                ? "unitOfMeasure"
                : "attributeList",
          },
        ]
      : []),
  ];

  const ondcPost = {
    productDisplayUnitOfMeasure: ondcInfo?.unitOfMeasure,
    netProductWeight: 0,
    ondcEnabled: "yes",

    ondc: {
      productCode: ondcInfo?.productCode,
      fragile: ondcInfo?.fragile,
      available_on_cod: ondcInfo?.available_on_cod,

      timeToShip: ondcInfo?.timeToShip
        ? formatTimeToShip(ondcInfo?.timeToShipUnit?.unit, ondcInfo?.timeToShip)
        : "",

      cancelTerms: {
        ...ondcInfo?.cancelTerms,
        cancellable: ondcInfo?.cancelTerms?.cancellable?.toLowerCase(),

        refundEligible: ondcInfo?.cancelTerms?.refundEligible?.toLowerCase(),
        cancellationFeeAmount: null,
      },

      returnTerms: {
        ...ondcInfo?.returnTerms,
        returnable: ondcInfo?.returnTerms?.returnable?.toLowerCase(),

        returnPeriod: ondcInfo?.returnTerms?.returnPeriod
          ? `P${ondcInfo?.returnTerms?.returnPeriod}D`
          : "",

        seller_pickup_return:
          ondcInfo?.returnTerms?.seller_pickup_return?.toLowerCase(),
      },
    },
  };
  return {
    productId: productDetails?.id,
    variantInfo: {
      variantId,
      masterVariant: true,
      masterProductVariantId: "",
      masterProductName: productInfo?.productName,
      variantSequence1: "",
      variants: attributesList,
    },
    profileId: profileId,
    businessId: businessId,
    productName: productInfo?.productName,
    productDescription: productInfo?.description,
    catalogType: "Product",
    label: [],
    searchText: "",
    brand: productInfo?.brand,
    origin: productInfo?.country?.ondcCountryCode || "",
    skuId: "",
    refLink: refLinkList || [],
    productPhoto: null,
    latitude: lat,
    longitude: long,
    status: productDetails?.status || "active",
    commerceEnabled: "YES",
    hyperLocal: "Y",
    productMainCategory: [
      {
        ...categoryInfo?.selectedBusinessCat,
        ondcCode: categoryInfo?.selectedOndcCat?.code || null,
        ondcValue: categoryInfo?.selectedOndcCat?.name || null,
        value: categoryInfo?.selectedBusinessCat?.name || null,
      },
    ],
    productSubCategory: categoryInfo?.selectedProductCat
      ? [
          {
            ...categoryInfo?.selectedProductCat,
            ondcSubCode: categoryInfo?.selectedOndcSubCat?.scCode1 || null,
            ondcSubValue:
              categoryInfo?.selectedOndcSubCat?.productSubCategory1 || null,
          },
        ]
      : [],
    productSubCategory2: categoryInfo?.selectedProductSubCat
      ? [
          {
            ...categoryInfo?.selectedProductSubCat,
            ondcSub2Code: null,
            ondcSub2Value: null,
          },
        ]
      : [],

    commerceStartDate: null,
    commerceEndDate: null,
    minOrderQuantity: null,
    maxOrderQuantity: null,
    productOriginalPrice: null,
    productSalePrice: null,
    gstInfo: {
      code:
        `${ondcInfo?.productCode?.key}:${ondcInfo?.productCode?.value}` || "",
      gstPercentage: productInfo?.gstPercentage || "",
    },
    measurementInfo: {
      weight: null,
      length: null,
      width: null,
      height: null,
    },
    taxDetails: [
      {
        code: "Inclusive of taxes",
        name: "Taxes Included",
        value: "false",
      },
    ],
    currencySymbol: "₹",
    unitOfMeasure: "Gram",
    availability: ["Yes"],
    deliveryType: [],
    shipmentDistance: "0",
    preference: 0,
    availableQuantity: null,
    soldQuantity: 0,
    alertQuantity: null,
    subscription: null,
    ...ondcPost,
  };
};

const photoObj = (data, index) => {
  const randomTypeImage = Math.floor(100000 + Math.random() * 900000);
  const type = `Product${index}-${randomTypeImage}`;

  return {
    name: `Product${index}`,
    type,
    mimeType: "image/jpeg",
    extension: "jpeg",
    replicate: false,
    bytesString: data,
  };
};

const preparePhoto = (data) => {
  let photo = [];
  if (data?.photo1) {
    photo.push(photoObj(data?.photo1, 1));
  }
  if (data?.photo2) {
    photo.push(photoObj(data?.photo2, 2));
  }
  if (data?.photo3) {
    photo.push(photoObj(data?.photo3, 3));
  }
  if (data?.photo4) {
    photo.push(photoObj(data?.photo4, 4));
  }

  return photo;
};

const getUnitOfMeasure = (variant, uom) => {
  const unitOfMeasure =
    variant?.variant1?.code === "uom"
      ? {
          unit: variant?.variant1?.inputValue,
          value: variant?.variant2?.inputValue,
        }
      : variant?.variant2?.code === "uom"
      ? {
          unit: variant?.variant2?.inputValue,
          value: variant?.variant3?.inputValue,
        }
      : uom;
  return unitOfMeasure;
};

const getProductName = (productName, selectedVariant, variant) => {
  let name = productName;
  if (selectedVariant?.variant1?.tag) {
    if (variant?.variant1?.code === "uom") {
      name =
        name +
        ` - ${variant?.variant2?.inputValue} ${variant?.variant1?.inputValue}`;
    } else {
      name =
        name +
        ` - ${
          variant?.variant1?.type === "codeValue"
            ? toTitleCase(variant?.variant1?.inputValue)
            : variant?.variant1?.inputValue
        }`;
    }
  }
  if (selectedVariant?.variant2?.tag && selectedVariant?.variant2?.value) {
    if (variant?.variant2?.code === "uom") {
      name =
        name +
        ` - ${variant?.variant3?.inputValue} ${variant?.variant2?.inputValue}`;
    } else if (variant?.variant2?.code === "uomValue") {
      name =
        name +
        ` - ${
          variant?.variant3?.type === "codeValue"
            ? toTitleCase(variant?.variant3?.inputValue)
            : variant?.variant3?.inputValue
        }`;
    } else {
      name =
        name +
        ` - ${
          variant?.variant2?.type === "codeValue"
            ? toTitleCase(variant?.variant2?.inputValue)
            : variant?.variant2?.inputValue
        }`;
    }
  }
  return name;
};

const getOndcSpecList = (ondcSpecList, variant) => {
  let specList = [...ondcSpecList];

  if (variant?.variant1?.code !== "uom") {
    specList.push(variant?.variant1);
  }
  if (
    variant?.variant2 &&
    variant?.variant2?.code !== "uom" &&
    variant?.variant2?.code !== "uomValue"
  ) {
    specList.push(variant?.variant2);
  }
  if (variant?.variant3 && variant?.variant3?.code !== "uomValue") {
    specList.push(variant?.variant3);
  }
  return parseDbObjectInsideArray(specList);
};

export const prepareVariantData = ({
  productInfo,
  selectedVariant,
  categoryInfo,
  ondcInfo,
  businessInfo,
  id,
  variant,
}) => {
  const profileId = getProfileId();
  const businessId = sessionStorage.getItem("selectedBusinessId");

  const refLinkList = productInfo?.refLinks?.filter(
    (item) => item?.code !== "" && item?.link !== ""
  );
  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";

  const variantSequence1 = variant?.main ? "main" : "";
  let attributesList = [];

  if (variant?.variant1?.code === "uom") {
    attributesList.push({
      code: variant?.variant1?.code,
      value: `${variant?.variant1?.inputValue} - ${variant?.variant2?.inputValue}`,
      tag: false,
      ondcAttribute: "unitOfMeasure",
    });
  } else {
    attributesList.push({
      code: variant?.variant1?.code,
      value: variant?.variant1?.inputValue,
      tag: false,
      ondcAttribute: "attributeList",
    });
  }

  if (variant?.variant2) {
    if (variant?.variant2?.code === "uom") {
      attributesList.push({
        code: variant?.variant2?.code,
        value: `${variant?.variant2?.inputValue} - ${variant?.variant3?.inputValue}`,
        tag: false,
        ondcAttribute: "unitOfMeasure",
      });
    } else if (variant?.variant2?.code !== "uomValue") {
      attributesList.push({
        code: variant?.variant2?.code,
        value: variant?.variant2?.inputValue,
        tag: false,
        ondcAttribute: "attributeList",
      });
    }
  }

  if (variant?.variant3 && variant?.variant3?.code !== "uomValue") {
    attributesList.push({
      code: variant?.variant3?.code,
      value: variant?.variant3?.inputValue,
      tag: false,
      ondcAttribute: "attributeList",
    });
  }

  const productPhoto = preparePhoto(variant);

  const productMainCategory = [
    {
      ...categoryInfo?.selectedBusinessCat,
      ondcCode: categoryInfo?.selectedOndcCat?.code || null,
      ondcValue: categoryInfo?.selectedOndcCat?.name || null,
      value: categoryInfo?.selectedBusinessCat?.name || null,
    },
  ];

  const productSubCategory = categoryInfo?.selectedProductCat
    ? [
        {
          ...categoryInfo?.selectedProductCat,
          ondcSubCode: categoryInfo?.selectedOndcSubCat?.scCode1 || null,
          ondcSubValue:
            categoryInfo?.selectedOndcSubCat?.productSubCategory1 || null,
        },
      ]
    : [];

  const productSubCategory2 = categoryInfo?.selectedProductSubCat
    ? [
        {
          ...categoryInfo?.selectedProductSubCat,
          ondcSub2Code: null,
          ondcSub2Value: null,
        },
      ]
    : [];

  const productDisplayUnitOfMeasure = getUnitOfMeasure(
    variant,
    ondcInfo?.unitOfMeasure
  );

  const productName = getProductName(
    productInfo?.productName,
    selectedVariant,
    variant
  );

  const ondcSpecs = getOndcSpecList(variant?.specList, variant);

  const ondcPost = {
    ...ondcSpecs,
    productDisplayUnitOfMeasure,
    netProductWeight: variant?.productWeight,
    ondcEnabled: "yes",

    ondc: {
      ...ondcSpecs?.ondc,
      productCode: {
        key: variant?.productCodeKey,
        value: variant?.productCodeValue,
      },
      fragile: ondcInfo?.fragile,
      available_on_cod: ondcInfo?.available_on_cod,

      timeToShip: ondcInfo?.timeToShip
        ? formatTimeToShip(ondcInfo?.timeToShipUnit?.unit, ondcInfo?.timeToShip)
        : "",

      cancelTerms: {
        ...ondcInfo?.cancelTerms,
        cancellable: ondcInfo?.cancelTerms?.cancellable?.toLowerCase(),

        refundEligible: ondcInfo?.cancelTerms?.refundEligible?.toLowerCase(),
        cancellationFeeAmount: null,
      },

      returnTerms: {
        ...ondcInfo?.returnTerms,
        returnable: ondcInfo?.returnTerms?.returnable?.toLowerCase(),

        returnPeriod: ondcInfo?.returnTerms?.returnPeriod
          ? `P${ondcInfo?.returnTerms?.returnPeriod}D`
          : "",

        seller_pickup_return:
          ondcInfo?.returnTerms?.seller_pickup_return?.toLowerCase(),
      },
    },
  };

  return {
    variantInfo: {
      variantId: id,
      masterProductVariantId: id,
      masterProductName: productInfo?.productName || "",
      masterVariant: false,
      variantSequence1,
      variants: attributesList,
    },

    profileId: profileId,
    businessId: businessId,
    productName,
    productDescription: variant?.description,
    catalogType: "Product",
    label: [],
    searchText: "",
    brand: productInfo?.brand,
    origin: productInfo?.country?.ondcCountryCode || "",
    skuId: variant?.skuId,
    refLink: refLinkList || [],
    productPhoto,
    latitude: lat,
    longitude: long,
    status: "active",
    commerceEnabled: "YES",
    hyperLocal: "Y",
    productMainCategory,
    productSubCategory,
    productSubCategory2,

    commerceStartDate: moment().startOf("day").toISOString(),
    commerceEndDate: moment().startOf("day").add(3, "years").toISOString(),
    minOrderQuantity: variant?.minQty,
    maxOrderQuantity: variant?.maxQty,
    productOriginalPrice: variant?.originalPrice,
    productSalePrice: variant?.offerPrice,
    gstInfo: {
      code: `${variant?.productCodeKey}:${variant?.productCodeValue}` || "",
      gstPercentage: variant?.gstPercentage || "",
    },
    measurementInfo: {
      weight: variant?.netProductWeight,
      length: variant?.productLength,
      width: variant?.productHeight,
      height: variant?.productWidth,
    },
    taxDetails: [
      {
        code: "Inclusive of taxes",
        name: "Taxes Included",
        value: "false",
      },
    ],
    currencySymbol: "₹",
    unitOfMeasure: "Gram",
    availability: ["Yes"],
    deliveryType: [],
    shipmentDistance: "0",
    preference: 0,
    availableQuantity: variant?.qty,
    soldQuantity: 0,
    alertQuantity: variant?.alertQty,
    subscription: null,
    ...ondcPost,
  };
};
export const prepareEditVariantData = ({
  productInfo,
  categoryInfo,
  ondcInfo,
  businessInfo,
  id,
  variant,
  productId,
  selectedVariant,
  status,
}) => {
  console.log("EDIT_STATUS:", status);
  const profileId = getProfileId();
  const businessId = sessionStorage.getItem("selectedBusinessId");

  const refLinkList = productInfo?.refLinks?.filter(
    (item) => item?.code !== "" && item?.link !== ""
  );
  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";

  const variantSequence1 = variant?.main ? "main" : "";
  let attributesList = [];

  if (variant?.variant1?.code === "uom") {
    attributesList.push({
      code: variant?.variant1?.code,
      value: `${variant?.variant1?.inputValue} - ${variant?.variant2?.inputValue}`,
      tag: false,
      ondcAttribute: "unitOfMeasure",
    });
  } else {
    attributesList.push({
      code: variant?.variant1?.code,
      value: variant?.variant1?.inputValue,
      tag: false,
      ondcAttribute: "attributeList",
    });
  }

  if (variant?.variant2) {
    if (variant?.variant2?.code === "uom") {
      attributesList.push({
        code: variant?.variant2?.code,
        value: `${variant?.variant2?.inputValue} - ${variant?.variant3?.inputValue}`,
        tag: false,
        ondcAttribute: "unitOfMeasure",
      });
    } else if (variant?.variant2?.code !== "uomValue") {
      attributesList.push({
        code: variant?.variant2?.code,
        value: variant?.variant2?.inputValue,
        tag: false,
        ondcAttribute: "attributeList",
      });
    }
  }

  if (variant?.variant3 && variant?.variant3?.code !== "uomValue") {
    attributesList.push({
      code: variant?.variant3?.code,
      value: variant?.variant3?.inputValue,
      tag: false,
      ondcAttribute: "attributeList",
    });
  }

  const productMainCategory = [
    {
      ...categoryInfo?.selectedBusinessCat,
      ondcCode: categoryInfo?.selectedOndcCat?.code || null,
      ondcValue: categoryInfo?.selectedOndcCat?.name || null,
      value: categoryInfo?.selectedBusinessCat?.name || null,
    },
  ];

  const productSubCategory = categoryInfo?.selectedProductCat
    ? [
        {
          ...categoryInfo?.selectedProductCat,
          ondcSubCode: categoryInfo?.selectedOndcSubCat?.scCode1 || null,
          ondcSubValue:
            categoryInfo?.selectedOndcSubCat?.productSubCategory1 || null,
        },
      ]
    : [];

  const productSubCategory2 = categoryInfo?.selectedProductSubCat
    ? [
        {
          ...categoryInfo?.selectedProductSubCat,
          ondcSub2Code: null,
          ondcSub2Value: null,
        },
      ]
    : [];

  const productDisplayUnitOfMeasure = getUnitOfMeasure(
    variant,
    ondcInfo?.unitOfMeasure
  );

  console.log("selectedVariant", selectedVariant);
  // const productName = variant?.productName;
  const productName = getProductName(
    productInfo?.productName,
    selectedVariant,
    variant
  );

  const ondcSpecs = getOndcSpecList(variant?.specList, variant);

  const ondcPost = {
    ...ondcSpecs,
    productDisplayUnitOfMeasure,
    netProductWeight: variant?.productWeight,
    ondcEnabled: "yes",

    ondc: {
      ...ondcSpecs?.ondc,
      productCode: {
        key: variant?.productCodeKey,
        value: variant?.productCodeValue,
      },
      fragile: ondcInfo?.fragile,
      available_on_cod: ondcInfo?.available_on_cod,

      timeToShip: ondcInfo?.timeToShip
        ? formatTimeToShip(ondcInfo?.timeToShipUnit?.unit, ondcInfo?.timeToShip)
        : "",

      cancelTerms: {
        ...ondcInfo?.cancelTerms,
        cancellable: ondcInfo?.cancelTerms?.cancellable?.toLowerCase(),

        refundEligible: ondcInfo?.cancelTerms?.refundEligible?.toLowerCase(),
        cancellationFeeAmount: null,
      },

      returnTerms: {
        ...ondcInfo?.returnTerms,
        returnable: ondcInfo?.returnTerms?.returnable?.toLowerCase(),

        returnPeriod: ondcInfo?.returnTerms?.returnPeriod
          ? `P${ondcInfo?.returnTerms?.returnPeriod}D`
          : "",

        seller_pickup_return:
          ondcInfo?.returnTerms?.seller_pickup_return?.toLowerCase(),
      },
    },
  };

  return {
    productId,
    variantInfo: {
      variantId: id,
      masterProductVariantId: id,
      masterProductName: productInfo?.productName || "",
      masterVariant: false,
      variantSequence1,
      variants: attributesList,
    },

    profileId: profileId,
    businessId: businessId,
    productName,
    productDescription: variant?.description,
    catalogType: "Product",
    label: [],
    searchText: "",
    brand: productInfo?.brand,
    origin: productInfo?.country?.ondcCountryCode || "",
    skuId: variant?.skuId,
    refLink: refLinkList || [],
    productPhoto: [],
    latitude: lat,
    longitude: long,
    status: status || "active",
    commerceEnabled: "YES",
    hyperLocal: "Y",
    productMainCategory,
    productSubCategory,
    productSubCategory2,

    commerceStartDate: moment().startOf("day").toISOString(),
    commerceEndDate: moment().startOf("day").add(3, "years").toISOString(),
    minOrderQuantity: variant?.minQty,
    maxOrderQuantity: variant?.maxQty,
    productOriginalPrice: variant?.originalPrice,
    productSalePrice: variant?.offerPrice,
    gstInfo: {
      code: `${variant?.productCodeKey}:${variant?.productCodeValue}`,
      gstPercentage: variant?.gstPercentage || "",
    },
    measurementInfo: {
      weight: variant?.netProductWeight,
      length: variant?.productLength,
      width: variant?.productHeight,
      height: variant?.productWidth,
    },
    taxDetails: [
      {
        code: "Inclusive of taxes",
        name: "Taxes Included",
        value: "false",
      },
    ],
    currencySymbol: "₹",
    unitOfMeasure: "Gram",
    availability: ["Yes"],
    deliveryType: [],
    shipmentDistance: "0",
    preference: 0,
    availableQuantity: variant?.qty,
    soldQuantity: 0,
    alertQuantity: variant?.alertQty,
    subscription: null,
    ...ondcPost,
  };
};

export const getVariant = (variant) => {
  if (!variant) {
    return {
      value: "",
      tag: "",
    };
  }

  return {
    value: variant?.value === "uom" ? "Unit of measure" : variant?.value,
    tag: variant?.tag ? "Yes" : "No",
  };
};

export const prepareViewProductVariantData = (data) => {
  console.log("prepareViewProductVariantData", data);
  const { productInfo, ondcSpecificationData, countryList } = data;

  const refLink =
    productInfo?.refLink?.length > 0
      ? productInfo?.refLink
      : [{ code: "", link: "" }];

  const unitSymbol =
    productInfo?.ondc?.timeToShip?.charAt(
      productInfo?.ondc?.timeToShip?.length - 1
    ) || "";

  const ondcData = {
    ondcEnabled: productInfo?.ondc?.ondcEnabled,
    timeToShipUnit: getTimeToShipUnitValue(unitSymbol),
    available_on_cod: productInfo?.ondc?.available_on_cod,
    fragile: productInfo?.ondc?.fragile == true,

    timeToShip: getTimeToShipValue(unitSymbol, productInfo?.ondc?.timeToShip),

    cancelTerms: {
      cancellable: productInfo?.ondc?.cancelTerms?.cancellable || "none",
      cancellationFeeAmount: null,
      cancellationFeePercentage:
        productInfo?.ondc?.cancelTerms?.cancellationFeePercentage || "",
      refundEligible: productInfo?.ondc?.cancelTerms?.refundEligible || "none",
    },

    returnTerms: {
      returnable: productInfo?.ondc?.returnTerms?.returnable || "none",
      returnPeriod: productInfo?.ondc?.returnTerms?.returnPeriod
        ? productInfo?.ondc?.returnTerms?.returnPeriod?.slice(1, -1)
        : "",
      seller_pickup_return:
        productInfo?.ondc?.returnTerms?.seller_pickup_return || "none",
    },

    productCode: {
      key: productInfo?.ondc?.productCode?.key,
      value: productInfo?.ondc?.productCode?.value || "",
    },

    unitOfMeasure: productInfo?.productDisplayUnitOfMeasure,
  };

  const productDetails = {
    productName: productInfo?.productName,
    description: productInfo?.productDescription,
    brand: productInfo?.brand,
    country: getSelectedCountryByCode(productInfo?.origin, countryList),
    skuId: productInfo?.skuId,
    taxesIncluded: "Yes",
    gstPercentage: productInfo?.gstInfo?.gstPercentage,

    refLinks: refLink,
  };

  const selectedVariant = {
    variant1: getVariant(productInfo?.variantInfo?.variants?.[0]),
    variant2: getVariant(
      productInfo?.variantInfo?.variants?.length > 1
        ? productInfo?.variantInfo?.variants?.[1]
        : null
    ),
  };

  const ondcDetails = {
    ondcEnabled: productInfo?.ondcEnabled,
    timeToShip: ondcData?.timeToShip,
    timeUnit: ondcData?.timeToShipUnit?.label,
    cod: ondcData?.available_on_cod ? "Yes" : "No",
    fragile: ondcData?.fragile ? "Yes" : "No",
    returnable: ondcData?.returnTerms?.returnable,
    returnPeriod: ondcData?.returnTerms?.returnPeriod,
    sellerPickup: ondcData?.returnTerms?.seller_pickup_return,
    cancellable: ondcData?.cancelTerms?.cancellable,
    refundEligible: ondcData?.cancelTerms?.refundEligible,
    cancellationFee: ondcData?.cancelTerms?.cancellationFeePercentage,
    dynamicSpecs: ondcSpecificationData,
    productCode: ondcData?.productCode?.key,
    productCodeValue: ondcData?.productCode?.value,
    unitOfMeasure: ondcData?.unitOfMeasure?.unit,
    unitOfMeasureValue: ondcData?.unitOfMeasure?.value,
  };

  console.log("preparedViewProductVariantData", {
    productDetails,
    ondcDetails,
    selectedVariant,
  });

  return {
    productDetails,
    ondcDetails,
    selectedVariant,
  };
};

const getFixedHeader = (selectedVariant) => {
  console.log("selectedVariantselectedVariant", selectedVariant);

  let fixedValues = [];
  if (selectedVariant?.variant1?.value === "Unit of measure") {
    fixedValues = [
      {
        id: "50",
        title: "Unit of measure",
        isRequired: true,
      },
      {
        id: "51",
        title: "UOM Value",
        isRequired: true,
      },
    ];
  } else {
    fixedValues.push({
      id: "01",
      title: capitalizeFirstCharacter(selectedVariant?.variant1?.value),
      isRequired: true,
    });
  }
  if (selectedVariant?.variant2?.value) {
    if (selectedVariant?.variant2?.value === "Unit of measure") {
      fixedValues.push({
        id: "50",
        title: "Unit of measure",
        isRequired: true,
      });
      fixedValues.push({
        id: "51",
        title: "UOM Value",
        isRequired: true,
      });
    } else {
      fixedValues.push({
        id: "02",
        title: capitalizeFirstCharacter(selectedVariant?.variant2?.value),
        isRequired: true,
      });
    }
  }
  return fixedValues;
};

const getFixedEditHeader = (selectedVariant) => {
  console.log("selectedVariantselectedVariant", selectedVariant);

  let fixedValues = [];
  if (selectedVariant?.variant1?.value?.code === "uom") {
    fixedValues = [
      {
        id: "50",
        title: "Unit of measure",
        isRequired: true,
      },
      {
        id: "51",
        title: "UOM Value",
        isRequired: true,
      },
    ];
  } else {
    fixedValues.push({
      id: "01",
      title: capitalizeFirstCharacter(
        selectedVariant?.variant1?.value?.displayName
      ),
      isRequired: true,
    });
  }
  if (selectedVariant?.variant2?.value) {
    if (selectedVariant?.variant2?.value?.code === "uom") {
      fixedValues.push({
        id: "50",
        title: "Unit of measure",
        isRequired: true,
      });
      fixedValues.push({
        id: "51",
        title: "UOM Value",
        isRequired: true,
      });
    } else {
      fixedValues.push({
        id: "02",
        title: capitalizeFirstCharacter(
          selectedVariant?.variant2?.value?.displayName
        ),
        isRequired: true,
      });
    }
  }
  return fixedValues;
};

export const prepareViewChildVariantProductData = ({
  childVariants,
  specification,
  fullSpecification,
  selectedVariant,
  sVariants,
  unitOfMeasurementData,
}) => {
  let variantData = [];

  console.log(
    "selectedVariantselectedVariantselectedVariant",
    selectedVariant,
    sVariants,
    unitOfMeasurementData
  );

  const mapByCode = fullSpecification?.details?.reduce((acc, obj) => {
    acc[obj.code] = obj;
    return acc;
  }, {});

  childVariants.forEach((productDetails) => {
    const array = specification?.details?.[0]?.attributes?.map((obj1) => {
      // Check if there is a matching object in the second array based on code
      if (mapByCode[obj1?.value]) {
        // Merge properties from the second array object to the first array object
        if (mapByCode[obj1?.value]?.dbObjectName === "list") {
          if (mapByCode[obj1?.value]?.type === "codeValue") {
            const colorList = extractNameCodePairs(
              mapByCode[obj1?.value]?.values
            );
            const colorCode = getValueByCode(
              productDetails?.ondc?.attributeList,
              mapByCode[obj1?.value]?.code
            );
            const colourName = getNameByCode(colorList, colorCode);
            return {
              ...obj1,
              required: obj1?.code,
              ...mapByCode[obj1?.value],
              inputValue: colourName || "",
              options: extractNames(mapByCode[obj1?.value]?.values),
              nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
            };
          }
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue:
              getValueByCode(
                productDetails?.ondc?.attributeList,
                mapByCode[obj1?.value]?.code
              ) || "",
          };
        }
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        if (mapByCode[obj1?.value]?.type === "radioButton") {
          const options = mapByCode[obj1?.value]?.radioOptions;
          const radioOptions = options?.map((option) => {
            return {
              ...option,
              value: getValueByPath(productDetails, option?.key),
            };
          });

          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            radioOptions,
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue:
            getValueByPath(
              productDetails,
              mapByCode[obj1?.value]?.dbObjectName
            ) || "",
        };
      } else {
        return obj1;
      }
    });

    console.log("ARRAy1230", array);
    const ondcSpecs = array?.filter(
      (data) =>
        data?.value !== selectedVariant?.variant1?.value &&
        data?.value !== selectedVariant?.variant2?.value
    );

    const variant1 =
      selectedVariant?.variant1?.value === "Unit of measure"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
            code: "uom",
            displayName: "Unit of measure",
          }
        : array.find((obj) => obj.value === selectedVariant?.variant1?.value);

    const variant2 =
      selectedVariant?.variant1?.value === "Unit of measure"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
          }
        : selectedVariant?.variant2?.value
        ? selectedVariant?.variant2?.value === "Unit of measure"
          ? {
              inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
              code: "uom",
              displayName: "Unit of measure",
            }
          : array.find((obj) => obj.value === selectedVariant?.variant2?.value)
        : null;

    const variant3 =
      selectedVariant?.variant2?.value === "Unit of measure"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
          }
        : selectedVariant?.variant1?.value === "Unit of measure" &&
          selectedVariant?.variant2
        ? array.find((obj) => obj.value === selectedVariant?.variant2?.value)
        : null;

    console.log("variant 1234", variant3);

    const productObj = {
      productId: productDetails?.id || "",
      variant1: variant1,
      variant2: variant2,
      variant3: variant3,
      description: productDetails?.productDescription || "",
      skuId: productDetails?.skuId || "",
      originalPrice: productDetails?.productOriginalPrice || "",
      offerPrice: productDetails?.productSalePrice || "",
      photo1: productDetails?.productPhoto?.[0]?.docURL || "",
      photo2: productDetails?.productPhoto?.[1]?.docURL || "",
      photo3: productDetails?.productPhoto?.[2]?.docURL || "",
      photo4: productDetails?.productPhoto?.[3]?.docURL || "",
      productWeight: productDetails?.netProductWeight || "",
      netProductWeight: productDetails?.measurementInfo?.weight || "",
      productLength: productDetails?.measurementInfo?.length || "",
      productHeight: productDetails?.measurementInfo?.height || "",
      productWidth: productDetails?.measurementInfo?.width || "",
      qty: productDetails?.availableQuantity || "",
      alertQty: productDetails?.alertQuantity || "",
      minQty: productDetails?.minOrderQuantity || "",
      maxQty: productDetails?.maxOrderQuantity || "",
      main: productDetails?.variantInfo?.variantSequence1 === "main",
      specList: ondcSpecs,
      gstPercentage: productDetails?.gstInfo?.gstPercentage,
      productCodeKey: productDetails?.ondc?.productCode?.key,
      productCodeValue: productDetails?.ondc?.productCode?.value,
    };

    variantData?.push(productObj);
  });

  const arraySpec = specification?.details?.[0]?.attributes?.map((obj1) => {
    // Check if there is a matching object in the second array based on code
    if (mapByCode[obj1?.value]) {
      // Merge properties from the second array object to the first array object
      if (mapByCode[obj1?.value]?.dbObjectName === "list") {
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          const colorList = extractNameCodePairs(
            mapByCode[obj1?.value]?.values
          );
          // const colorCode = getValueByCode(
          //   productDetails?.ondc?.attributeList,
          //   mapByCode[obj1?.value]?.code
          // );
          // const colourName = getNameByCode(colorList, colorCode);
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
        };
      }
      if (mapByCode[obj1?.value]?.display === "N") {
        return {
          ...obj1,
          required: "o",
          ...mapByCode[obj1?.value],
          inputValue: mapByCode[obj1?.value]?.defaultValue,
        };
      }
      if (mapByCode[obj1?.value]?.type === "codeValue") {
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
          options: extractNames(mapByCode[obj1?.value]?.values),
          nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
        };
      }
      if (mapByCode[obj1?.value]?.type === "radioButton") {
        const options = mapByCode[obj1?.value]?.radioOptions;
        const radioOptions = options?.map((option) => {
          return {
            ...option,
            value: "",
          };
        });

        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          radioOptions,
        };
      }
      return {
        ...obj1,
        required: obj1?.code,
        ...mapByCode[obj1?.value],
        inputValue: "",
      };
    } else {
      return obj1;
    }
  });

  const selectedVariant1 = {
    variant1: getEditVariant(sVariants?.[0], arraySpec, []),
    variant2:
      sVariants?.length > 1
        ? getEditVariant(
            sVariants?.length > 1 ? sVariants?.[1] : null,
            arraySpec,
            []
          )
        : null,
  };

  const fixedValues = getFixedEditHeader(selectedVariant1);
  const productHeader = VARIANT_PRODUCT_TABLE_HEADER.slice(0, -1);
  const ondcHeader = variantData?.[0]?.specList
    ?.filter((param) => param.display !== "N")
    ?.map((param, index) => ({
      id: 14 + index, // Create an id starting from "01", "02", etc.
      title: param.displayName,
      isRequired: param.required === "M" || param.required === "m", // Set isRequired to true if required is "M"
      hint: param?.hintText,
    }));

  const tableHeader1 = [...fixedValues, ...productHeader];
  const tableHeader2 = [...fixedValues, ...ondcHeader];
  const mobileTableHeader = [
    ...fixedValues,
    {
      id: 33,
      title: "",
    },
  ];

  console.log("Variant Details", variantData, tableHeader1, tableHeader2);

  return {
    variantData,
    tableHeader1,
    tableHeader2,
    mobileTableHeader,
    selectedVariant1,
  };
};

const getEditVariant = (variant, arraySpec, values) => {
  console.log("variantvariantvariant", variant, arraySpec);
  if (!variant) {
    return {
      value: "",
      tag: "",
    };
  }

  return {
    value:
      variant?.value === "uom"
        ? {
            inputValue: "",
            code: "uom",
            displayName: "Unit of measure",
            value: "uom",
            type: "data",
            id: "1",
            validation: [],
            values,
          }
        : arraySpec?.find((obj) => obj.value === variant?.value),
    tag: variant?.tag ? "Yes" : "No",
  };
};

export const prepareEditChildVariantProductData = ({
  childVariants,
  specification,
  fullSpecification,
  unitOfMeasurementData,
  sVariants,
}) => {
  let variantData = [];

  const values = unitOfMeasurementData?.map((obj) => obj?.value);

  const mapByCode = fullSpecification?.details?.reduce((acc, obj) => {
    acc[obj.code] = obj;
    return acc;
  }, {});

  const arraySpec = specification?.details?.[0]?.attributes?.map((obj1) => {
    // Check if there is a matching object in the second array based on code
    if (mapByCode[obj1?.value]) {
      // Merge properties from the second array object to the first array object
      if (mapByCode[obj1?.value]?.dbObjectName === "list") {
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          const colorList = extractNameCodePairs(
            mapByCode[obj1?.value]?.values
          );
          // const colorCode = getValueByCode(
          //   productDetails?.ondc?.attributeList,
          //   mapByCode[obj1?.value]?.code
          // );
          // const colourName = getNameByCode(colorList, colorCode);
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
        };
      }
      if (mapByCode[obj1?.value]?.display === "N") {
        return {
          ...obj1,
          required: "o",
          ...mapByCode[obj1?.value],
          inputValue: mapByCode[obj1?.value]?.defaultValue,
        };
      }
      if (mapByCode[obj1?.value]?.type === "codeValue") {
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
          options: extractNames(mapByCode[obj1?.value]?.values),
          nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
        };
      }
      if (mapByCode[obj1?.value]?.type === "radioButton") {
        const options = mapByCode[obj1?.value]?.radioOptions;
        const radioOptions = options?.map((option) => {
          return {
            ...option,
            value: "",
          };
        });

        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          radioOptions,
        };
      }
      return {
        ...obj1,
        required: obj1?.code,
        ...mapByCode[obj1?.value],
        inputValue: "",
      };
    } else {
      return obj1;
    }
  });

  console.log("sVariantssVariants", sVariants, mapByCode, arraySpec);

  const selectedVariant = {
    variant1: getEditVariant(sVariants?.[0], arraySpec, values),
    variant2:
      sVariants?.length > 1
        ? getEditVariant(
            sVariants?.length > 1 ? sVariants?.[1] : null,
            arraySpec,
            values
          )
        : null,
  };

  console.log(
    "Ondc Specification",
    specification,
    fullSpecification,
    mapByCode,
    selectedVariant
  );

  childVariants.forEach((productDetails) => {
    const array = specification?.details?.[0]?.attributes?.map((obj1) => {
      // Check if there is a matching object in the second array based on code
      if (mapByCode[obj1?.value]) {
        // Merge properties from the second array object to the first array object
        if (mapByCode[obj1?.value]?.dbObjectName === "list") {
          if (mapByCode[obj1?.value]?.type === "codeValue") {
            const colorList = extractNameCodePairs(
              mapByCode[obj1?.value]?.values
            );
            const colorCode = getValueByCode(
              productDetails?.ondc?.attributeList,
              mapByCode[obj1?.value]?.code
            );
            const colourName = getNameByCode(colorList, colorCode);
            return {
              ...obj1,
              required: obj1?.code,
              ...mapByCode[obj1?.value],
              inputValue: colourName || "",
              options: extractNames(mapByCode[obj1?.value]?.values),
              nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
            };
          }
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue:
              getValueByCode(
                productDetails?.ondc?.attributeList,
                mapByCode[obj1?.value]?.code
              ) || "",
          };
        }
        if (mapByCode[obj1?.value]?.display === "N") {
          return {
            ...obj1,
            required: "o",
            ...mapByCode[obj1?.value],
            inputValue: mapByCode[obj1?.value]?.defaultValue,
          };
        }
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        if (mapByCode[obj1?.value]?.type === "radioButton") {
          const options = mapByCode[obj1?.value]?.radioOptions;
          const radioOptions = options?.map((option) => {
            return {
              ...option,
              value: getValueByPath(productDetails, option?.key),
            };
          });

          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            radioOptions,
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue:
            getValueByPath(
              productDetails,
              mapByCode[obj1?.value]?.dbObjectName
            ) || "",
        };
      } else {
        return obj1;
      }
    });

    const ondcSpecs = array?.filter(
      (data) =>
        data?.value !== selectedVariant?.variant1?.value?.code &&
        data?.value !== selectedVariant?.variant2?.value?.code
    );

    const variant1 =
      selectedVariant?.variant1?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
            code: "uom",
            displayName: "Unit of measure",
            value: "uom",
            type: "data",
            id: "1",
            values,
            validation: [],
          }
        : array.find(
            (obj) => obj.value === selectedVariant?.variant1?.value?.code
          );

    const variant2 =
      selectedVariant?.variant1?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
            value: "uomValue",
            type: "freeform",
            id: "2",
            values: [],
            validation: [],
          }
        : selectedVariant?.variant2?.value
        ? selectedVariant?.variant2?.value?.code === "uom"
          ? {
              inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
              code: "uom",
              displayName: "Unit of measure",
              value: "uom",
              type: "data",
              id: "1",
              values,
              validation: [],
            }
          : array.find(
              (obj) => obj.value === selectedVariant?.variant2?.value?.code
            )
        : null;

    const variant3 =
      selectedVariant?.variant2?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
            value: "uomValue",
            type: "freeform",
            id: "2",
            values: [],
            validation: [],
          }
        : selectedVariant?.variant1?.value?.code === "uom" &&
          selectedVariant?.variant2
        ? array.find(
            (obj) => obj.value === selectedVariant?.variant2?.value?.code
          )
        : null;

    const productObj = {
      productId: productDetails?.id || "",
      variant1: variant1,
      variant2: variant2,
      variant3: variant3,
      productName: productDetails?.productName,
      description: productDetails?.productDescription || "",
      skuId: productDetails?.skuId || "",
      originalPrice: productDetails?.productOriginalPrice || "",
      offerPrice: productDetails?.productSalePrice || "",
      photo1: productDetails?.productPhoto?.[0]?.docURL || "",
      photo2: productDetails?.productPhoto?.[1]?.docURL || "",
      photo3: productDetails?.productPhoto?.[2]?.docURL || "",
      photo4: productDetails?.productPhoto?.[3]?.docURL || "",
      productWeight: productDetails?.netProductWeight || "",
      netProductWeight: productDetails?.measurementInfo?.weight || "",
      productLength: productDetails?.measurementInfo?.length || "",
      productHeight: productDetails?.measurementInfo?.height || "",
      productWidth: productDetails?.measurementInfo?.width || "",
      qty: productDetails?.availableQuantity || "",
      alertQty: productDetails?.alertQuantity || "",
      minQty: productDetails?.minOrderQuantity || "",
      maxQty: productDetails?.maxOrderQuantity || "",
      main: productDetails?.variantInfo?.variantSequence1 === "main",
      specList: ondcSpecs,
      changed: false,
      photos: productDetails?.productPhoto,
      addPhotos: [],
      deletePhotos: [],
      gstPercentage: productDetails?.gstInfo?.gstPercentage,
      productCodeKey: productDetails?.ondc?.productCode?.key,
      productCodeValue: productDetails?.ondc?.productCode?.value,
    };

    variantData?.push(productObj);
  });

  const fixedValues = getFixedEditHeader(selectedVariant);
  const ondcHeader =
    variantData?.length > 0
      ? variantData?.[0]?.specList
          ?.filter((param) => param.display !== "N")
          ?.map((param, index) => ({
            id: 14 + index, // Create an id starting from "01", "02", etc.
            title: param.displayName,
            isRequired: param.required === "M" || param.required === "m", // Set isRequired to true if required is "M"
            hint: param?.hintText,
          }))
      : [];

  const tableHeader1 = [
    { id: "18", title: "MAIN" },
    ...fixedValues,
    ...VARIANT_PRODUCT_TABLE_HEADER,
  ];
  const tableHeader2 = [
    ...fixedValues,
    ...ondcHeader,
    {
      id: "101",
      title: "Action",
    },
  ];
  const mobileTableHeader = [
    ...fixedValues,
    {
      id: 33,
      title: "",
    },
  ];

  console.log(
    "Variant Details",
    variantData,
    tableHeader1,
    tableHeader2,
    selectedVariant
  );

  return {
    variantData,
    tableHeader1,
    tableHeader2,
    mobileTableHeader,
    selectedVariant,
  };
};

export const prepareEditPreviewVariantData = (ondcData) => {
  const ondcDetails = {
    ondcEnabled: "Yes",
    timeToShip: ondcData?.timeToShip,
    timeUnit: ondcData?.timeToShipUnit?.label,
    cod: ondcData?.available_on_cod ? "Yes" : "No",
    fragile: ondcData?.fragile ? "Yes" : "No",
    returnable: ondcData?.returnTerms?.returnable,
    returnPeriod: ondcData?.returnTerms?.returnPeriod,
    sellerPickup: ondcData?.returnTerms?.seller_pickup_return,
    cancellable: ondcData?.cancelTerms?.cancellable,
    refundEligible: ondcData?.cancelTerms?.refundEligible,
    cancellationFee: ondcData?.cancelTerms?.cancellationFeePercentage,
    productCode: ondcData?.productCode?.key,
    productCodeValue: ondcData?.productCode?.value,
    unitOfMeasure: ondcData?.unitOfMeasure?.unit,
    unitOfMeasureValue: ondcData?.unitOfMeasure?.value,
  };
  return ondcDetails;
};

export const getVariantValues = (productInfo) => {
  if (!productInfo?.variantInfo?.variants?.length) {
    return null;
  }

  let data = {};

  const [firstVariant, secondVariant] = productInfo.variantInfo.variants;

  const processVariant = (variant, dataKey1, dataKey2 = null) => {
    if (variant?.code === "uom") {
      const trimmedValue = variant.value.trim();
      const words = trimmedValue.split(" ");

      data[dataKey1] = words[0];
      if (dataKey2) {
        data[dataKey2] = words[words.length - 1];
      }
    } else {
      data[dataKey1] = variant?.value;
    }
  };

  if (firstVariant) {
    processVariant(firstVariant, "variant1", "variant2");
  }

  if (secondVariant) {
    processVariant(secondVariant, "variant2", "variant3");
  }

  console.log("Data_V", data);
  return data;
};

export const prepareCopyChildVariantProductData = ({
  childVariants,
  specification,
  fullSpecification,
  unitOfMeasurementData,
  sVariants,
}) => {
  let variantData = [];

  const values = unitOfMeasurementData?.map((obj) => obj?.value);

  const mapByCode = fullSpecification?.details?.reduce((acc, obj) => {
    acc[obj.code] = obj;
    return acc;
  }, {});

  const arraySpec = specification?.details?.[0]?.attributes?.map((obj1) => {
    // Check if there is a matching object in the second array based on code
    if (mapByCode[obj1?.value]) {
      // Merge properties from the second array object to the first array object
      if (mapByCode[obj1?.value]?.dbObjectName === "list") {
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          const colorList = extractNameCodePairs(
            mapByCode[obj1?.value]?.values
          );
          // const colorCode = getValueByCode(
          //   productDetails?.ondc?.attributeList,
          //   mapByCode[obj1?.value]?.code
          // );
          // const colourName = getNameByCode(colorList, colorCode);
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
        };
      }
      if (mapByCode[obj1?.value]?.display === "N") {
        return {
          ...obj1,
          required: "o",
          ...mapByCode[obj1?.value],
          inputValue: mapByCode[obj1?.value]?.defaultValue,
        };
      }
      if (mapByCode[obj1?.value]?.type === "codeValue") {
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue: "",
          options: extractNames(mapByCode[obj1?.value]?.values),
          nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
        };
      }
      if (mapByCode[obj1?.value]?.type === "radioButton") {
        const options = mapByCode[obj1?.value]?.radioOptions;
        const radioOptions = options?.map((option) => {
          return {
            ...option,
            value: "",
          };
        });

        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          radioOptions,
        };
      }
      return {
        ...obj1,
        required: obj1?.code,
        ...mapByCode[obj1?.value],
        inputValue: "",
      };
    } else {
      return obj1;
    }
  });

  console.log("sVariantssVariants", sVariants, mapByCode, arraySpec);

  const selectedVariant = {
    variant1: getEditVariant(sVariants?.[0], arraySpec, values),
    variant2:
      sVariants?.length > 1
        ? getEditVariant(
            sVariants?.length > 1 ? sVariants?.[1] : null,
            arraySpec,
            values
          )
        : null,
  };

  console.log(
    "Ondc Specification",
    specification,
    fullSpecification,
    mapByCode,
    selectedVariant
  );

  childVariants.forEach((productDetails) => {
    const array = specification?.details?.[0]?.attributes?.map((obj1) => {
      // Check if there is a matching object in the second array based on code
      if (mapByCode[obj1?.value]) {
        // Merge properties from the second array object to the first array object
        if (mapByCode[obj1?.value]?.dbObjectName === "list") {
          if (mapByCode[obj1?.value]?.type === "codeValue") {
            const colorList = extractNameCodePairs(
              mapByCode[obj1?.value]?.values
            );
            const colorCode = getValueByCode(
              productDetails?.ondc?.attributeList,
              mapByCode[obj1?.value]?.code
            );
            const colourName = getNameByCode(colorList, colorCode);
            return {
              ...obj1,
              required: obj1?.code,
              ...mapByCode[obj1?.value],
              inputValue: colourName || "",
              options: extractNames(mapByCode[obj1?.value]?.values),
              nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
            };
          }
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue:
              getValueByCode(
                productDetails?.ondc?.attributeList,
                mapByCode[obj1?.value]?.code
              ) || "",
          };
        }
        if (mapByCode[obj1?.value]?.display === "N") {
          return {
            ...obj1,
            required: "o",
            ...mapByCode[obj1?.value],
            inputValue: mapByCode[obj1?.value]?.defaultValue,
          };
        }
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        if (mapByCode[obj1?.value]?.type === "radioButton") {
          const options = mapByCode[obj1?.value]?.radioOptions;
          const radioOptions = options?.map((option) => {
            return {
              ...option,
              value: getValueByPath(productDetails, option?.key),
            };
          });

          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            radioOptions,
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue:
            getValueByPath(
              productDetails,
              mapByCode[obj1?.value]?.dbObjectName
            ) || "",
        };
      } else {
        return obj1;
      }
    });

    const ondcSpecs = array?.filter(
      (data) =>
        data?.value !== selectedVariant?.variant1?.value?.code &&
        data?.value !== selectedVariant?.variant2?.value?.code
    );

    const variant1 =
      selectedVariant?.variant1?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
            code: "uom",
            displayName: "Unit of measure",
            value: "uom",
            type: "data",
            id: "1",
            values,
            validation: [],
          }
        : array.find(
            (obj) => obj.value === selectedVariant?.variant1?.value?.code
          );

    const variant2 =
      selectedVariant?.variant1?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
            value: "uomValue",
            type: "freeform",
            id: "2",
            values: [],
            validation: [],
          }
        : selectedVariant?.variant2?.value
        ? selectedVariant?.variant2?.value?.code === "uom"
          ? {
              inputValue: productDetails?.productDisplayUnitOfMeasure?.unit,
              code: "uom",
              displayName: "Unit of measure",
              value: "uom",
              type: "data",
              id: "1",
              values,
              validation: [],
            }
          : array.find(
              (obj) => obj.value === selectedVariant?.variant2?.value?.code
            )
        : null;

    const variant3 =
      selectedVariant?.variant2?.value?.code === "uom"
        ? {
            inputValue: productDetails?.productDisplayUnitOfMeasure?.value,
            code: "uomValue",
            displayName: "UOM Value",
            value: "uomValue",
            type: "freeform",
            id: "2",
            values: [],
            validation: [],
          }
        : selectedVariant?.variant1?.value?.code === "uom" &&
          selectedVariant?.variant2
        ? array.find(
            (obj) => obj.value === selectedVariant?.variant2?.value?.code
          )
        : null;

    const productObj = {
      productId: "",
      variant1: variant1,
      variant2: variant2,
      variant3: variant3,
      productName: "",
      description: "",
      skuId: productDetails?.skuId || "",
      originalPrice: productDetails?.productOriginalPrice || "",
      offerPrice: productDetails?.productSalePrice || "",
      photo1: "",
      photo2: "",
      photo3: "",
      photo4: "",
      productWeight: productDetails?.netProductWeight || "",
      netProductWeight: productDetails?.measurementInfo?.weight || "",
      productLength: productDetails?.measurementInfo?.length || "",
      productHeight: productDetails?.measurementInfo?.height || "",
      productWidth: productDetails?.measurementInfo?.width || "",
      qty: productDetails?.availableQuantity || "",
      alertQty: productDetails?.alertQuantity || "",
      minQty: productDetails?.minOrderQuantity || "",
      maxQty: productDetails?.maxOrderQuantity || "",
      main: productDetails?.variantInfo?.variantSequence1 === "main",
      specList: ondcSpecs,
      changed: false,
      photos: productDetails?.productPhoto,
      addPhotos: [],
      deletePhotos: [],
      gstPercentage: productDetails?.gstInfo?.gstPercentage,
      productCodeKey: productDetails?.ondc?.productCode?.key,
      productCodeValue: productDetails?.ondc?.productCode?.value,
    };

    variantData?.push(productObj);
  });

  const fixedValues = getFixedEditHeader(selectedVariant);
  const ondcHeader =
    variantData?.length > 0
      ? variantData?.[0]?.specList
          ?.filter((param) => param.display !== "N")
          ?.map((param, index) => ({
            id: 14 + index, // Create an id starting from "01", "02", etc.
            title: param.displayName,
            isRequired: param.required === "M" || param.required === "m", // Set isRequired to true if required is "M"
            hint: param?.hintText,
          }))
      : [];

  const tableHeader1 = [
    { id: "18", title: "MAIN" },
    ...fixedValues,
    ...VARIANT_PRODUCT_TABLE_HEADER,
  ];
  const tableHeader2 = [
    ...fixedValues,
    ...ondcHeader,
    {
      id: "101",
      title: "Action",
    },
  ];
  const mobileTableHeader = [
    ...fixedValues,
    {
      id: 33,
      title: "",
    },
  ];

  console.log(
    "Variant Details",
    variantData,
    tableHeader1,
    tableHeader2,
    selectedVariant
  );

  return {
    variantData,
    tableHeader1,
    tableHeader2,
    mobileTableHeader,
    selectedVariant,
  };
};

export function mergeValidatedArrays(array1, array2) {
  console.log("Merge Needed Arrays", array1, array2);
  const mergedArray = array1.map((item1) => {
    // Find the corresponding item in array2 with the same id
    const item2 = array2.find((item) => item?.productId === item1?.productId);
    const matchingItem = array2.find((item2) => {
      return (
        item1.variant1?.inputValue === item2.variant1?.inputValue &&
        item1.variant2?.inputValue === item2.variant2?.inputValue &&
        item1.variant3?.inputValue === item2.variant3?.inputValue
      );
    });

    // Return a new object that merges properties from both arrays
    return {
      ...item1, // Take all properties from array1
      specList: matchingItem?.specList || null, // Take specList from array2 (fallback to null if not found)
      specificationError: matchingItem?.specificationError || false, // Take specErr from array2 (fallback to false if not found)
    };
  });

  return mergedArray;
}
